import { BaseService } from './baseService';
import { Client, ClientFormData, ClientListResponse, ClientQueryParams } from '../types/clients';

export class ClientService extends BaseService {
  private readonly endpoint = '/clients';

  async createClient(clientData: ClientFormData): Promise<Client> {
    const response = await this.api.post(this.endpoint, clientData);
    return response.data.client;
  }

  async getClient(id: string): Promise<Client> {
    const response = await this.api.get(`${this.endpoint}/${id}`);
    return response.data.client;
  }

  async updateClient(id: string, updates: Partial<ClientFormData>): Promise<Client> {
    const response = await this.api.put(`${this.endpoint}/${id}`, updates);
    return response.data.client;
  }

  async deleteClient(id: string): Promise<void> {
    await this.api.delete(`${this.endpoint}/${id}`);
  }

  async listClients(params?: ClientQueryParams): Promise<ClientListResponse> {
    const response = await this.api.get(this.endpoint, { params });
    return {
      clients: response.data.clients,
      count: response.data.count,
      nextToken: response.data.nextToken
    };
  }

  async searchClients(query: string, params?: Omit<ClientQueryParams, 'search'>): Promise<ClientListResponse> {
    return this.listClients({ ...params, search: query });
  }
}

export const clientService = new ClientService();